// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"R1-z","yourQuestionLabel":"S1-z","notAuthedMessage":"T1-z","form":"U1-z","textarea":"V1-z","error":"W1-z","disabled":"X1-z","edited":"Y1-z","submit":"Z1-z"};